module.exports = __webpack_public_path__ + "img/doc_export.ac3cbdc4.gif";